import {ODATA_COLUMN_TYPES} from "../../utils/odata";

export const DIMENSION_TYPE = {
  territorial: ODATA_COLUMN_TYPES.territorial,
  dimension: ODATA_COLUMN_TYPES.dimension,
  image: ODATA_COLUMN_TYPES.image,
  addr: ODATA_COLUMN_TYPES.addr,
  lat: ODATA_COLUMN_TYPES.lat,
  lon: ODATA_COLUMN_TYPES.lon,
  website: ODATA_COLUMN_TYPES.website,
  phone: ODATA_COLUMN_TYPES.phone,
  note: ODATA_COLUMN_TYPES.note,
  mail: ODATA_COLUMN_TYPES.mail,
  coordinates: ODATA_COLUMN_TYPES.coordinates,
  dateTime: ODATA_COLUMN_TYPES.dateTime,
  time: ODATA_COLUMN_TYPES.time,
  day: ODATA_COLUMN_TYPES.day,
  month: ODATA_COLUMN_TYPES.month,
  year: ODATA_COLUMN_TYPES.year,
  quarter: ODATA_COLUMN_TYPES.quarter,
  quadrimester: ODATA_COLUMN_TYPES.quadrimester,
  semester: ODATA_COLUMN_TYPES.semester,
  identifier: ODATA_COLUMN_TYPES.identifier
};

export const POINT_DATA_MAP_TYPE_POINTS = "points";
export const POINT_DATA_MAP_TYPE_CLUSTER = "cluster";
export const POINT_DATA_MAP_TYPE_HEATMAP = "heatmap";

export const DEFAULT_GEOJSON_MAP_SETTINGS = {
  pointMapType: POINT_DATA_MAP_TYPE_POINTS
};

export const getPointDataSelectorOptions = t => [
  {label: t("modules.viewerGeojsonMap.pointDataSelector.values.points.label"), value: POINT_DATA_MAP_TYPE_POINTS},
  {label: t("modules.viewerGeojsonMap.pointDataSelector.values.cluster.label"), value: POINT_DATA_MAP_TYPE_CLUSTER},
  {label: t("modules.viewerGeojsonMap.pointDataSelector.values.heatmap.label"), value: POINT_DATA_MAP_TYPE_HEATMAP}
];

export const getLabelField = (item, labelField, labelFieldList = []) => {
  const attrs = item?.attributes || {};

  // Case-insensitive map: lowercase -> original key
  const ciMap = {};
  for (const k in attrs) {
    const lower = k.toLowerCase();
    if (!ciMap[lower]) ciMap[lower] = k;
  }

  // Helper to find value with case-insensitive key
  const findCI = name => {
    if (!name) return undefined;
    const lower = name.toLowerCase();
    const originalKey = Object.prototype.hasOwnProperty.call(attrs, name) ? name : ciMap[lower];
    return originalKey ? attrs[originalKey] : undefined;
  };

  // 1. Priority to labelField parameter (case-insensitive)
  if (labelField) {
    const val = findCI(labelField);
    if (val != null) return val;
  }

  // 2. Fallback: iterate labelFieldList (case-insensitive)
  for (const candidate of labelFieldList) {
    const val = findCI(candidate);
    if (val != null) return val;
  }

  return item.id;
};
